import React from 'react';
import ComponentBox from 'components/BusinessLogic/Components/ComponentBox';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import ComponentSummary from 'components/BusinessLogic/Components/ComponentSummary';

function Insurance({
    insurance, showCommission, requestQuoteComponentId, requestQuoteId,
})
{
    return (
        <ComponentBox
            typeName="Insurance"
            description={insurance.name}
            requestQuoteId={requestQuoteId}
            requestQuoteComponentId={requestQuoteComponentId}
            icon={faPlus}
            summaryContent={(
                <ComponentSummary
                    showCommission={showCommission}
                    className="tw-pt-5"
                    currency={insurance.currency}
                    total={insurance.total_price}
                    commission={parseFloat(insurance.travel_agent_commissionable_amount)}
                />
            )}
        >
            <div className="tw-px-3 tw-w-full tw-rounded-t-md tw-py-1 tw-mt-1  tw-h-[250px]" style={{ height: 180 }}>
                <div className="tw-flex tw-flex-row tw-flex-wrap">
                    <div className="tw-w-full tw-mb-9"><b>Type: </b> {insurance.insurance.type}</div>
                    <div className="tw-w-full tw-mb-6"></div>

                </div>
            </div>
        </ComponentBox>
    );
}

Insurance.defaultProps = {
    showCommission: true,
    insurance: {
        name: '',
        total_price: 0,
        insurance: {
            type: '',
            commission: 0,
        },
        currency: {
            currency_change: 0,
            code: '',
        },
    },
};

Insurance.propTypes = {
    showCommission: PropTypes.bool,
    requestQuoteComponentId: PropTypes.number,
    requestQuoteId: PropTypes.number,
    insurance: PropTypes.shape({
        travel_agent_commissionable_amount: PropTypes.any,
        name: PropTypes.string,
        total_price: PropTypes.any,
        insurance: PropTypes.shape({
            type: PropTypes.string,
            commission: PropTypes.any,
        }),
        currency: PropTypes.shape({
            currency_change: PropTypes.number,
            code: PropTypes.string,
        }),
    }),
};
export default Insurance;
